<template>
    <section :style="style" class="refer-banner-section" >
        <div class="container refer-container">
            <div class="refer-card">
                <div class="refer-content">
                    <h2 id="refer-banner-heading" class="refer-title" :aria-label="bannerHeadingAria">
                        Earn up to <span class="highlight">{{ maxRewardFormatted }}</span>
                    </h2>
                    <p class="refer-description" :aria-label="referDescriptionAria">
                        <template v-if="minInvestmentIsFromCampaign">
                            Earn when your friend signs up, completes KYC, and invests, with a minimum investment of
                            {{ minInvestmentFormatted }}.
                        </template>
                        <template v-else>
                            Earn when your friend signs up, completes KYC, and invests.
                        </template>
                    </p>
                    <CommonButton text="Invite & Earn" :color="colors.buttonBg" width="200px" height="50px"
                        :font-size="'21px'" :href="investEquirizeBaseUrl"
                        ctaName="invite-and-earn-button" ariaLabel="Invite and Earn"
                        class="refer-button" />
                </div>
                <div class="refer-illustration">
                    <img src="~assets/images/home/referCard.svg" alt="Invite and Earn Illustration" class="img-fluid"
                        loading="lazy" aria-label="Invite and Earn Illustration" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useTheme } from "~/composables/useTheme";
const { colors } = useTheme();
const { investorUrl } = useInvestorPlatform();

const {
    maxRewardFormatted,
    minInvestmentFormatted,
    minInvestmentIsFromCampaign,
} = await useActiveReferralCampaign();

const bannerHeadingAria = computed(() => `Earn up to ${maxRewardFormatted.value}`);

const referDescriptionAria = computed(() => {
    if (minInvestmentIsFromCampaign.value) {
        return `Earn when your friend signs up, completes KYC, and invests, with a minimum investment of ${minInvestmentFormatted.value}.`;
    }
    return "Earn when your friend signs up, completes KYC, and invests.";
});

const investEquirizeBaseUrl = computed(() => investorUrl("/profile/referral"));

defineProps<{
    style?: any
}>()
</script>

<style scoped>
.refer-banner-section {
    padding: 60px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.refer-container {
    /* max-width: 1200px; */
    margin: 0 auto;
    width: 80%;
}

.refer-card {
    background-color: var(--darkBlue);
    border-radius: 24px;
    padding: 40px 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    color: var(--buttonText);
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    position: relative;
}

.refer-content {
    flex: 1;
    max-width: 900px;
    z-index: 2;
}

.refer-title {
    color: var(--buttonText);
    /* Force white color in dark card */
    font-size: 36px;
    font-weight: 600;
    margin-bottom: 16px;
    line-height: 1.2;
}

.highlight {
    color: var(--yellow) !important;
    /* Yellow accent */
}

.refer-description {
    color: rgba(255, 255, 255, 0.9) !important;
    font-size: 24px;
    margin-bottom: 32px;
    line-height: 1.6;
}


.invite-btn:active {
    transform: translateY(0);
}

.refer-illustration {
    flex-shrink: 0;
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
}

.refer-illustration img {
    max-height: 250px;
}

@media (max-width: 1400px) {
    .refer-container {
        width: 90%;
    }
}

@media (max-width: 991px) {
    .refer-card {
        flex-direction: column;
        padding: 40px 30px;
        gap: 30px;
        text-align: center;
    }

    .refer-title {
        font-size: 28px;
    }

    .refer-description {
        font-size: 18px;
    }

    .refer-illustration {
        width: 200px;
    }
}
</style>
